import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractColorInput} from "../abstract-color-input";
import {TranslateService} from "@ngx-translate/core";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditColorInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-color-input",
    styleUrls: ["./edit-color-input.component.scss"],
    templateUrl: "./edit-color-input.component.html"
})
export class FUIEditColorInputComponent extends FUIAbstractColorInput {
    constructor(elementRef: ElementRef,
                eventsService: FUIEventsService,
                translateService: TranslateService,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, eventsService, translateService, changeDetectorRef);
    }
}
